import React, { useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux'
export default function Protected(props) {
  // const flag = useSelector(state => state.userReducer)
    const {Component} = props
    // console.log("flag protected",flag.Login.token)
    const navigate = useNavigate()
    useEffect(()=>{
        let login=localStorage.token
        if(!login){
            navigate('/')
        }
    })
  return (
    <div>   
      <Component/>
    </div>
  )
}
